






import { Component, Prop, PropSync } from 'vue-property-decorator'
import Vue from 'vue'

/**
 * 오버레이 컴포넌트입니다.
 *
 * 활성 컴포넌트를 부각시키고, 사용자의 행동을 유도합니다.
 */
@Component
export default class HdsOverlay extends Vue {
  name = 'HdsOverlay'

  @PropSync('on', { type: Boolean, default: false }) onSync!: boolean

  /**
   * Fixed or Absolute
   */
  @Prop({ type: Boolean, default: false }) fixed!: boolean

  /**
   * 오버레이를 클릭했을때 창을 닫는 기능을 비활성화 합니다.
   */
  @Prop({ type: Boolean, default: false }) noClickOutside!: boolean

  /**
   * 오버레이 색상을 변경합니다.
   */
  @Prop({ type: String, default: 'rgba(0, 0, 0, 0.25)' })
  overlayColor!: string

  get overlayClasses() {
    return {
      'hds-overlay': true,
      'hds-no-click-outside': this.noClickOutside,
      'hds-fixed': this.fixed,
      'hds-on': this.onSync,
      'hds-off': !this.onSync,
    }
  }

  get overlayStyles() {
    return {
      backgroundColor: this.overlayColor,
    }
  }

  click() {
    this.$emit('click')
  }
}
